/*
 * Corporate gifting page: copy-to-clipboard for the email / phone contacts.
 * Loaded with defer by sections/corp-gifting.liquid. The quote form has its own
 * script, shipped by the halio-core app block.
 */
(function () {
  'use strict';

  function init() {
    var status = document.querySelector('[data-corp-copy-status]');
    document.querySelectorAll('[data-corp-copy]').forEach(function (btn) {
      if (btn.hasAttribute('data-corp-ready')) return;
      btn.setAttribute('data-corp-ready', '');
      var timer;

      function done() {
        document.querySelectorAll('[data-corp-copy]').forEach(function (b) { b.classList.remove('is-copied'); });
        btn.classList.add('is-copied');
        if (status) status.textContent = (btn.getAttribute('aria-label') || '').replace('Copy', 'Copied');
        clearTimeout(timer);
        timer = setTimeout(function () {
          btn.classList.remove('is-copied');
          if (status) status.textContent = '';
        }, 1800);
      }

      function fallback(text) {
        try {
          var t = document.createElement('textarea');
          t.value = text;
          t.setAttribute('readonly', '');
          t.style.position = 'fixed';
          t.style.opacity = '0';
          document.body.appendChild(t);
          t.select();
          document.execCommand('copy');
          document.body.removeChild(t);
          done();
        } catch (e) {
          console.warn('corp-gifting: copy failed', e);
        }
      }

      btn.addEventListener('click', function () {
        var text = btn.getAttribute('data-corp-copy') || '';
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done).catch(function () { fallback(text); });
        } else {
          fallback(text);
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
